import React, { useState, useEffect } from "react";
import { Row, Col, Label } from "reactstrap";

import "./style.module.scss";

function PersonSubAsset({ subAssetClasses, isChecked, handleCheck, checked }) {
  const [checkedList, setCheckedList] = useState([]);

  const updateCheckedList = () => {
    let checkedList = [];
    if (checked) {
      checked.forEach((item) => {
        checkedList.push(item.PersonSubAssetClassId);
      });
      setCheckedList(checkedList);
    }
  };

  useEffect(() => {
    updateCheckedList();
  }, [checked]);

  return (
    <div>
      <Row>
        <div className="header">
          <Label
            style={{
              fontWeight: 500,
              fontSize: "15px",
              display: "block",
              color: "black",
            }}
          >
            Person SubAsset Selected:
          </Label>
          <div className="list-container">
            {subAssetClasses &&
              subAssetClasses.map((item, index) => (
                <div key={item.SubAssetClassId}>
                  <input
                    value={item.SubAssetClassName}
                    type="checkbox"
                    onChange={(e) => handleCheck(item.SubAssetClassId)}
                    checked={checkedList.includes(item.SubAssetClassId)}
                  />
                  <Label style={{ paddingLeft: "10px" }}>{item.SubAssetClassName}</Label>
                </div>
              ))}
          </div>
        </div>
      </Row>
      <Row></Row>
    </div>
  );
}

export default PersonSubAsset;
